import { createSlice } from '@reduxjs/toolkit';
import { createSliceHook, makeActionCreator } from '../helpers';
import {
  QCTasksListFetchAction,
  QCTasksListFetchSuccessAction,
  QCTasksListSetFiltersAction,
  QCTasksListState,
} from './QCTasksList.types';

const initialState: QCTasksListState = {
  loading: false,
  error: undefined,
  data: null,
  filters: {
    patientCode: '',
    assignee: '',
    status: '',
    page: 0,
    size: 10,
    sort: 'latestUpload,desc',
  },
};

const { actResolve, actReject, act } = makeActionCreator<QCTasksListState>();

export const QCTasksListSlice = createSlice({
  name: 'QCTasksList',
  initialState,
  reducers: {
    fetchQCTasksList: act<QCTasksListFetchAction['payload']>(({ filters }) => ({
      filters,
      loading: true,
      error: undefined,
    })),
    fetchQCTasksListSuccess:
      actResolve<QCTasksListFetchSuccessAction['payload']>('data'),
    fetchQCTasksListError: actReject(),
    setFilters: (state, action: QCTasksListSetFiltersAction) => {
      if (!action.payload.filterQuery) {
        return;
      }
      state.filters = {
        ...state.filters,
        [action.payload.filterQuery]: action.payload.filterValue,
      };
    },
    clear: state => {
      state.loading = false;
      state.error = undefined;
      state.data = null;
      state.filters = initialState.filters;
    },
  },
});

export const actions = {
  ...QCTasksListSlice.actions,
};

export const useQCTasksListSlice = createSliceHook(
  QCTasksListSlice.name,
  actions
);
